import React from 'react'
import { Bloc, Header } from '../ImportAll'

export default function Loading() {
    return (
        <div>
            <Header title="Ne bougez pas ⏱️" subTitle="Chargement ..." />
            <div className="Container placeholdercontainer">
                <Bloc key="key217" nbcolumn={1} height={90} onetextline />
                <Bloc key="key218" nbcolumn={2} height={90} gauche />
                <Bloc key="key219" nbcolumn={2} height={90} droit />
                <Bloc key="key220" nbcolumn={3} height={90} gauche />
                <Bloc key="key221" nbcolumn={3} height={90} milieu />
                <Bloc key="key222" nbcolumn={3} height={90} droit />
                <Bloc key="key223" nbcolumn={4} height={90} gauche />
                <Bloc key="key224" nbcolumn={4} height={90} milieu />
                <Bloc key="key225" nbcolumn={4} height={90} milieu />
                <Bloc key="key226" nbcolumn={4} height={90} droit />
            </div>
        </div>
    )
}
